import { useAppStore } from '../stores/useAppStore';
import Page from '../components/Page';
import CardSpeaker from '../components/CardSpeaker';
import { CAROUSEL_TYPES } from '../constants/carouselTypes';

function PageCiscoSpeakingSessions() {
  const { content, setCardTouchPos } = useAppStore();
  const { openCarousel } = useAppStore((state) => state.carousel);

  const speakers = content.cisco_speaking_sessions || [];

  const handleCardClick = (event, index) => {
      let x, y;
  
      if (event.touches) {
        // Evento táctil
        x = event.touches[0].clientX;
        y = event.touches[0].clientY;
      } else {
        // Evento de ratón
        x = event.clientX;
        y = event.clientY;
      }
      setCardTouchPos({x, y});
      
      openCarousel(index, CAROUSEL_TYPES.SPEAKERS);
    };

  return (
    <Page className="pr-[36.0625rem] pb-[24.75rem]">
      
      <div className="pl-[8.25rem] flex flex-row h-full pt-[calc(31.25rem-var(--header-height))] gap-[10.75rem]">
        {speakers.map((speaker, index) => (
          <CardSpeaker key={speaker.id} item={speaker} isOpen={false} onClick={(event) => handleCardClick(event, index)} />
        ))}
      </div>
    </Page>
  );
}

export default PageCiscoSpeakingSessions;